import axios from 'axios'
import AxiosMockAdapter from 'axios-mock-adapter'
import { cardLinkApiClientBaseUrl } from '@/src/card-linking/api-client/cardLinkApiClientBaseUrl'
import {
    getEnrolledCardsMock,
    postActivateGiftMock,
    postEnrolledCardsMock,
} from '@/src/card-linking/api-client/cardLinkApiMockResponses'

export const mockClient = axios.create({
    baseURL: cardLinkApiClientBaseUrl,
})

const mockAdapter = new AxiosMockAdapter(mockClient, {
    delayResponse: 50,
})

mockAdapter
    .onGet(/\/card-link-session\/enrolled-cards$/)
    .reply(200, getEnrolledCardsMock)
    .onPost(/\/card-link-session\/enrolled-cards$/)
    .reply(201, postEnrolledCardsMock)
    .onPost(/\/card-link-session\/gift\/activate$/)
    .reply(201, postActivateGiftMock)
